import { Language } from '../components/LanguageSelector/translations';

// Mapping delle lingue ai locale codes
const languageToLocale: Record<Language, string> = {
  'it': 'it-IT',
  'en': 'en-US',
  'nl': 'nl-NL',
  'es': 'es-ES',
  'tr': 'tr-TR',
  'de': 'de-DE',
  'fr': 'fr-FR'
};

export const formatDate = (dateString: string, language: Language, options?: Intl.DateTimeFormatOptions) => {
  const locale = languageToLocale[language] || 'en-US';
  
  const defaultOptions: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options
  };

  const formattedDate = new Date(dateString).toLocaleDateString(locale, defaultOptions);
  
  // Capitalize first letter of each word (weekday and month)
  return formattedDate.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatDateShort = (dateString: string, language: Language) => {
  const locale = languageToLocale[language] || 'en-US';
  
  const formattedDate = new Date(dateString).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
  
  // Capitalize first letter of each word (month)
  return formattedDate.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatDateTime = (dateString: string, language: Language) => {
  const locale = languageToLocale[language] || 'en-US';
  
  const formattedDate = new Date(dateString).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  
  // Capitalize first letter of each word (month)
  return formattedDate.replace(/\b\w/g, (char) => char.toUpperCase());
};
